import React, { Component } from "react";

class ArrivesAFLPage extends Component {
    render() {
        return(null);
    }
}

export default ArrivesAFLPage;